import Vue from 'vue';
import Element from 'element-ui';
import '../element-variables.scss';
import locale from 'element-ui/lib/locale/lang/en';

if (localStorage.lang=="en-US") {
    Vue.use(Element, { locale });
} else {
    Vue.use(Element);
}